import { CustomClaimValue, Users } from "@app/shared";
import { useFetch } from "../../../hooks";
import { AuthorizeView } from "../../shared/AuthorizeView";
import { UsersTable } from "../../shared";


type GlobalUsersProps = {
};

export const GlobalUsers: React.FC<GlobalUsersProps> = (props) => {
    const [users, , usersHelper] = useFetch(() => Users.getAllUsers());
    
    return (
        <AuthorizeView claim={CustomClaimValue.SuperAdmin}>
            <UsersTable users={users} isLoading={usersHelper.isLoading} onChange={() => usersHelper.refreshData()} />
        </AuthorizeView>
    );
}